import React from 'react';
import { formatLabel } from 'utils/helpers';
import { hasContent, renderPrecautions, renderArray } from './utils';

const HandlingSection = ({ chemicalDetails }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-hand-holding mr-2"></i>Handling
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6">
        {chemicalDetails.handling && Object.values(chemicalDetails.handling).some(value => hasContent(value)) ? (
          Object.entries(chemicalDetails.handling).map(([key, value]) => (
            hasContent(value) && (
              <div key={key} className={`rounded-lg p-6 shadow border bg-gray-50 ${key === 'precautions' ? 'border-yellow-500 bg-yellow-100' : ''}`}>
                <div className="font-bold text-lg mb-2">{formatLabel(key)}</div>
                <div>{key === 'precautions' || key === 'spill_protection' ? renderPrecautions(value) : renderArray(value)}</div>
              </div>
            )
          ))
        ) : (
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <div className="rounded-lg p-6 shadow border bg-gray-50">
              <div className="text-center">No handling information available.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HandlingSection;
